<template>
  <div>
    <modal-relatar-problema-simulado ref="modalRelatarProblemaSimulado" :simuladoId="simuladoId" :questaoId="questaoAtiva.id" />
    <section class="simulados ml-md-5 ml-lg-0" :class="{'modoProva': !isModoTreino}">
      <div class="d-flex justify-content-around align-items-start align-items-lg-center titulo flex-column flex-lg-row">
        <span class="nomeSimulado mb-4 mb-lg-0">{{ nome }}</span>
        <div>
          <span class="numeroQuestaoRoxo">Questão {{ ordem }}</span>
          <span class="numeroQuestao">de {{ quantidadeQuestoes }}</span>
        </div>
      </div>
      <div class="box-branco border-0">
        <div class="simulado-prova container" v-if="nome">
          <div class="row">
            <div class="col-lg-3 col-dir">
              <div class="d-flex align-items-center justify-content-center mb-3 flex-column botoesModoSimulado">
                <ul class="nav nav-pills">
                    <li class="nav-item d-flex align-items-center justify-content-center w-100">
                        <div class="align-items-center d-flex form-group justify-content-between mb-0">
                            <label class="mr-3" for="mt">Modo treino</label>
                            <div class="custom-control custom-switch d-inline" id="mt">
                                <input type="checkbox" class="custom-control-input" id="modo-treino" :checked="isModoTreino" name="modo_treino" @change="setModoTreino">
                                <label class="custom-control-label" for="modo-treino"></label>
                            </div>
                        </div>
                        <i class="mdi mdi-help-circle-outline text-muted ml-2" v-b-popover.hover.top="'Ative o modo treino para acompanhar os resultado com comentários a cada questão'"></i>
                    </li>
                </ul>
                <div class="tempo-prova d-flex flex-column">
                  <p class="title">Tempo de prova</p>
                  <div class="d-flex align-items-center align-self-center">
                    <p v-if="timer == 'ativo'"><span id="minutes">{{tempo.minutos}}</span>:<span id="seconds">{{tempo.segundos}}</span></p>
                    <span class="timerHidden" id="countdownHidden" v-if="timer == 'inativo'"><span>--</span> : <span>--</span></span>
                    <a href="javascript:void(0)" @click="alternaTimer()"><i class="fa fa-eye ml-3"></i></a>
                  </div>
                </div>
                <div class="desempenho">
                  <p class="title">Desempenho</p>
                  <ul>
                    <li><i class="mdi mdi-check-circle roxo"></i><span class="acertos" v-show="isModoTreino">{{ desempenho.acertos }}</span> acertos</li>
                    <li><i class="mdi mdi-close-circle laranja"></i><span class="erros" v-show="isModoTreino">{{ desempenho.erros }}</span> erros</li>
                    <li><i class="mdi mdi-frequently-asked-questions verde"></i><span class="sem_resposta" v-show="isModoTreino">{{ desempenho.naoRespondidas }}</span> não respondidas</li>
                  </ul>
                </div>
              </div>
            </div>
            <transition name="slide-fade" mode="out-in">
              <div class="col-12 col-lg-6 conteudo-questao pr-md-4 pl-md-4" :key="questaoAtiva.id">

                <div class="img-questao text-center" v-if="questaoAtiva.imagensEnunciado && questaoAtiva.imagensEnunciado.length">
                  <img v-for="imagem in questaoAtiva.imagensEnunciado"
                      :src="imagem"
                      alt="Texto explicando imagem detalhadamente"
                      class="img-fluid d-inline-block m-3"/>
                </div>

                <p class="enunciado mt-4 mb-3" v-html="questaoAtiva.pergunta"></p>

                <div class="alternativas mt-4">
                  <div class="custom-control custom-checkbox pl-0" v-for="opcaoResposta in questaoAtiva.opcoes">
                    <a vx-if="isRevisao">
                      <label class="alternativa mb-2 d-flex align-items-center justify-content-start" :for="`resposta-${opcaoResposta.id}`" :class="{ 'selecionada': respostaQuestao == opcaoResposta.id, ...classOpcaoQuestao(opcaoResposta) }" :style="{ borderColor: colorOpcaoQuestao(opcaoResposta), background: backgroundColorOpcaoQuestao(opcaoResposta) }">
                        <div>
                          <span class="opcaoLetra ml-5 d-block">{{ opcaoResposta.letra }}</span>
                        </div>
                        <div>
                          <span class="opcaoTexto d-block">{{ opcaoResposta.texto }}</span>
                        </div>
                        <input type="checkbox" class="custom-control-input" :id="`resposta-${opcaoResposta.id}`"
                              :value="opcaoResposta.id" v-model="respostaQuestao" @click="singleCheckbox($event, opcaoResposta)" :disabled="isRevisao">
                      </label>
                    </a>
                    <p v-if="isModoTreino" class="mb-3" :style="{ color: colorOpcaoQuestao(opcaoResposta) }">{{ textoRespostaOpcaoQuestao(opcaoResposta) }}</p>
                  </div>
                </div>

                <div class="materiais" v-if="false">
                  <p>Materiais recomendados</p>
                  <div class="row">
                    <div v-for="material in materiais" class="col-12 col-md-6">
                      <div>
                        <a href="#">
                          <p>{{ material.titulo }}</p>
                          <p>{{ material.descricao }}</p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </transition>
            <div class="col-12 col-lg-3">
              <button class="btn btn-link pl-lg-0 relateProblema text-center text-lg-left" id="relatarProblemaEmSimuladoBotao" @click="mostrarModalRelatoDeProblemaSimulado()">
                <i class="mdi mdi-bullhorn mr-1" id="relatarProblemaEmSimuladoIcone"></i> Relatar um problema
              </button>
              <div class="comentario mt-4" v-if="exibirComentario && questaoAtiva.comentario && execucao ==='S'">
                <div class="box-comentario">
                  <p class="mb-3 title d-block">Explicação do professor</p>
                  <div class="imgs-comentario mb-2" v-if="questaoAtiva.imagensComentario && questaoAtiva.imagensComentario.length">
                    <a v-for="imagem in questaoAtiva.imagensComentario"
                      class="col-4 my-2"
                      data-toggle="modal"
                      data-target="#modalComentario"
                      @click="imagemModal = imagem">
                      <img :src="imagem" alt="" class="img-fluid">
                    </a>
                  </div>
                  <div class="p" v-html="questaoAtiva.comentario"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="mt-4 d-flex flex-wrap align-items-center justify-content-center flex-wrap btn-simulado-acoes">
                <a href="javascript:void(0)" v-on:click.prevent="questaoAnterior()" class="btn btn-lg btn-outline-dark mx-3 order-1" v-if="possuiQuestaoAnterior()" :class="{ disabled: !possuiQuestaoAnterior() }" :disabled="!possuiQuestaoAnterior()"><i class="mdi mdi-arrow-left"></i> Anterior</a>
                <a href="javascript:void(0)" v-on:click.prevent="proximaQuestao()" class="btn btn-lg btn-secondary mx-3 order-5" v-if="possuiProximaQuestao()" :class="{ disabled: !possuiProximaQuestao() }" :disabled="!possuiProximaQuestao()">Próxima <i class="mdi mdi-arrow-right"></i></a>
                <a href="javascript:void(0)" @click="$router.push(`/simulados/resultado/${simuladoId}`)" class="btn btn-lg btn-secondary order-3 d-none d-lg-block" v-if="isRevisao">Voltar para resultado</a>
                <a href="javascript:void(0)" @click="finalizarSimulado" class="btn btn-lg btn-finalizar btn-success rounded-pill order-4 d-none d-lg-block" v-else><i class="mdi mdi-check"></i> Finalizar</a>
                <a href="javascript:void(0)" @click="$router.push('/simulados/listar')" class="btn btn-primary btn-pausar order-3 d-none d-lg-block" v-if="!isRevisao"><i class="mdi mdi-pause"></i> Pausar</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="modal fade" id="modalComentario" tabindex="-1" role="dialog" aria-labelledby="modalComentario" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <img :src="imagemModal" alt="Texto explicando imagem detalhadamente" class="img-fluid mx-auto d-block" />
      </div>
    </div>
    <b-modal :no-close-on-backdrop="true" hide-footer hide-header id="modalModoProva" content-class="modal-prova mx-auto" >
      <div class="text-center mb-4 container-text mx-auto">
          <span><b>Como deseja iniciar o simulado?</b></span>
      </div>
      <div class="text-center mb-4 container-text mx-auto">
          <span>Modo <b>Prova</b> o resultado será apresentado no final do simulado.</span>
      </div>
      <div class="text-center mb-4 container-text mx-auto">
          <span>Modo <b>Treino</b> os resultados serão apresentados a cada questão com comentários.</span>
      </div>
      <div class="text-center">
          <div class="d-flex align-items-center justify-content-center mt-4">
              <a href="javascript:void(0)" class="btn btn-secondary mr-3" id="modoSimulado" @click="modoSimulado()">Modo Treino</a>
              <a href="javascript:void(0)" class="btn btn-secondary mr-3" id="modoProva" @click="modoProva()">Modo Prova</a>
          </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import SimuladoAPI from '@/api/simulado-api'
import Swal from 'sweetalert2'
import ImageUtils from '@/core/utils/image-utils'
import ResponseUtils from '@/core/utils/response-utils'
import TipoPraticaSimulado from '@/core/types/tipo-pratica-simulado'
import DateUtils from '@/core/utils/date-utils'
import 'bootstrap/js/dist/modal'
import ModalRelatarProblemaSimulado from '@/modules/Simulados/components/ModalRelatarProblemaSimulado'

export default {
  name: 'SimuladoProvaView',
  components: { ModalRelatarProblemaSimulado },
  data () {
    return {
      simuladoId: null,
      imagemModal: '',
      nome: '',
      ordem: 1,
      tipo: 0,
      tempo: { minutos: 0, segundos: 0 },
      respostaQuestao: [],
      respostaCorreta: null,
      exibirComentario: false,
      quantidadeQuestoes: 0,
      desempenho: {
        acertos: 0,
        erros: 0,
        naoRespondidas: 0
      },
      materiais: [
        { titulo: 'Resumo', descricao: 'Histologia: Trato Digestório' },
        { titulo: 'Resumo', descricao: 'Histologia: Trato Digestório' },
        { titulo: 'Resumo', descricao: 'Histologia: Trato Digestório' }
      ],
      questaoAtiva: {},
      questoes: [],
      execucao: localStorage.getItem('execucao'),
      timer: localStorage.getItem('timerSimulado') || 'ativo',
      tipo_modo_simulado_id: null
    }
  },

  created () {
    this.simuladoId = parseInt(this.$route.params.simulado)

    if (this.$route.params.ordem) {
      this.ordem = this.$route.params.ordem
    }
  },

  mounted () {
    const loader = this.$loading.show()

    if (this.isRevisao) {
      this.execucao = 'S'
      SimuladoAPI.obterResultado(this.simuladoId).then(data => {
        this.questoes = data.filter(this.obterCondicaoRevisao).map((item, index) => {
          return { id: index, respondida: item.resposta && item.resposta > 0, ordem: item.ordem }
        })

        this.quantidadeQuestoes = data.length

        SimuladoAPI.obterQuestaoSimulado(this.simuladoId, this.ordem).then(data => {
          this.nome = data.etapa.simulado_nome
          this.ordem = data.etapa.questao_atual
          this.desempenho = {
            acertos: data.desempenho.acertadas,
            erros: data.desempenho.incorretas,
            naoRespondidas: data.desempenho.sem_resposta
          }

          this.questaoAtiva = this.mountQuestaoAtiva(data.questao)

          this.tipo_modo_simulado_id = data.etapa.tipo_modo_simulado_id

          loader.hide()
        }).catch(error => ResponseUtils.handleError(error, loader))
      }).catch(error => ResponseUtils.handleError(error, loader))
    } else {
      this.tipo = TipoPraticaSimulado.PROVA.id

      SimuladoAPI.obterQuestaoSimulado(this.simuladoId, this.ordem).then(data => {
        this.nome = data.etapa.simulado_nome
        this.ordem = data.etapa.questao_atual
        this.desempenho = {
          acertos: data.desempenho.acertadas,
          erros: data.desempenho.incorretas,
          naoRespondidas: data.desempenho.sem_resposta
        }

        this.quantidadeQuestoes = data.questao_status.length

        this.questoes = data.questao_status.map(item => {
          return { id: item.questao_id, respondida: item.respondida === 1, ordem: item.questao_ordem }
        })
        this.questaoAtiva = this.mountQuestaoAtiva(data.questao)

        this.tipo_modo_simulado_id = data.etapa.tipo_modo_simulado_id

        if (this.tempo.minutos === 0 && this.tempo.segundos === 0 && data.tempo_prova && (data.tempo_prova.minutos || data.tempo_prova.segundos)) {
          this.tempo = { minutos: data.tempo_prova.minutos, segundos: data.tempo_prova.segundos }
        }

        let duration = DateUtils.getDuration({ 'minutes': this.tempo.minutos, 'seconds': this.tempo.segundos })

        window.setInterval(() => {
          duration = DateUtils.getDuration(duration.asSeconds() + 1, 'seconds')
          this.tempo = {
            minutos: String(duration.minutes()).padStart(2, '0'),
            segundos: String(duration.seconds()).padStart(2, '0')
          }
        }, 1000)

        this.gravarTempo()
        window.setInterval(() => {
          this.gravarTempo()
        }, 5000)

        loader.hide()
        if (this.tipo_modo_simulado_id === 1) {
          this.abrirModalModoProva()
        } else if (this.tipo_modo_simulado_id === 2) {
          this.modoSimulado()
        } else if (this.tipo_modo_simulado_id === 3) {
          this.modoProva()
        }
      }).catch(error => ResponseUtils.handleError(error, loader))
    }
  },

  computed: {
    isRevisao: function () {
      return this.$route.path.includes('/revisao')
    },

    isRevisaoErros: function () {
      return this.isRevisao && this.$route.path.includes('/erros')
    },

    isRevisaoAcertos: function () {
      return this.isRevisao && this.$route.path.includes('/acertos')
    },

    isRevisaoNaoRespondidas: function () {
      return this.isRevisao && this.$route.path.includes('/nao-respondidas')
    },

    isRevisaoCompleta: function () {
      return this.isRevisao && this.$route.path.includes('/todas')
    },

    isModoProva: function () {
      return this.tipo === TipoPraticaSimulado.PROVA.id
    },

    isModoTreino: function () {
      return this.tipo === TipoPraticaSimulado.TREINO.id
    },

    configEmpresa: function () {
      return this.$store.getters.empresa
    }
  },

  methods: {
    abrirModalImagemComentario: function (imagem) {
      this.imagemModal = imagem
      this.$el.querySelector('#modalComentario').show()
    },

    singleCheckbox: function (event, opcao) {
      const loader = this.$loading.show()

      if (!event.target.checked) {
        this.respostaQuestao = []
        SimuladoAPI.limparResposta(this.simuladoId, this.ordem).then(() => {
          this.carregarQuestaoAtiva(this.ordem)
          loader.hide()
        })

        this.questoes.find(item => item.ordem === this.ordem).respondida = false
      } else {
        this.respostaQuestao = [opcao.id]
        SimuladoAPI.registrarResposta(this.simuladoId, this.ordem, opcao.id).then(() => {
          this.carregarQuestaoAtiva(this.ordem)
          loader.hide()
        })

        this.questoes.find(item => item.ordem === this.ordem).respondida = true
      }
    },

    classOpcaoQuestao: function (opcao) {
      if (this.execucao === 'S') {
        if (this.respostaQuestao.length && (this.isModoTreino || this.isRevisao)) {
          if (opcao.id === this.respostaCorreta) {
            return 'text-success'
          } else if (this.respostaQuestao.includes(opcao.id)) {
            return 'text-danger'
          }
        }
      }
    },

    obterClassQuestao: function (questao) {
      if (this.ordem === questao.ordem) {
        return 'atual'
      } else if (questao.respondida) {
        return 'respondida'
      }
    },

    obterCondicaoRevisao: function (item) {
      if (this.isRevisaoErros) return item.resposta && item.resposta !== item.opcao_correta
      else if (this.isRevisaoAcertos) return item.resposta && item.resposta === item.opcao_correta
      else if (this.isRevisaoNaoRespondidas) return item.resposta === null || item.resposta === false || item.resposta === 0
      else return true
    },

    exibirQuestao: function (ordem) {
      if (this.isRevisaoErros) this.$router.push(`/simulados/prova/${this.simuladoId}/questao/${ordem}/revisao/erros`)
      else if (this.isRevisaoAcertos) this.$router.push(`/simulados/prova/${this.simuladoId}/questao/${ordem}/revisao/acertos`)
      else if (this.isRevisaoNaoRespondidas) this.$router.push(`/simulados/prova/${this.simuladoId}/questao/${ordem}/revisao/nao-respondidas`)
      else if (this.isRevisaoCompleta) this.$router.push(`/simulados/prova/${this.simuladoId}/questao/${ordem}/revisao/todas`)
      else this.$router.push(`/simulados/prova/${this.simuladoId}/questao/${ordem}`)

      this.carregarQuestaoAtiva(ordem)
    },

    obterIndexQuestaoAtiva: function () {
      return this.questoes.findIndex(q => this.questaoAtiva.id === q.id)
    },
    possuiQuestaoAnterior: function () {
      return this.questoes.length && this.ordem > this.questoes[0].ordem
    },

    possuiProximaQuestao: function () {
      return this.ordem < this.quantidadeQuestoes
    },

    questaoAnterior: function () {
      if (this.possuiQuestaoAnterior()) {
        this.exibirQuestao(this.questoes[this.questoes.findIndex(item => item.ordem === this.ordem) - 1].ordem)
      }
    },

    proximaQuestao: function () {
      if (this.possuiProximaQuestao()) {
        this.exibirQuestao(this.questoes[this.questoes.findIndex(item => item.ordem === this.ordem) + 1].ordem)
      }
    },

    carregarQuestaoAtiva: function (ordem) {
      const loader = this.$loading.show()

      SimuladoAPI.obterQuestaoSimulado(this.simuladoId, ordem).then(data => {
        this.ordem = data.etapa.questao_atual
        this.desempenho = {
          acertos: data.desempenho.acertadas,
          erros: data.desempenho.incorretas,
          naoRespondidas: data.desempenho.sem_resposta
        }

        this.questaoAtiva = this.mountQuestaoAtiva(data.questao)

        loader.hide()
      })
    },

    mountQuestaoAtiva: function (questao) {
      if (questao) {
        const questaoAtiva = {
          id: questao.id,
          pergunta: questao.enunciado,
          comentario: questao.comentario_feedback,
          opcoes: []
        }

        if (questao.imagem_comentario && questao.imagem_comentario.length) {
          questaoAtiva.imagensComentario = questao.imagem_comentario && questao.imagem_comentario.length
            ? questao.imagem_comentario.map(item => ImageUtils.obterUrlCompletaImagem(item.imagem_comentario, 'questoes-imagem/')) : []
        }

        if (questao.imagem_enunciado && questao.imagem_enunciado.length) {
          questaoAtiva.imagensEnunciado = questao.imagem_enunciado && questao.imagem_enunciado.length
            ? questao.imagem_enunciado.map(item => ImageUtils.obterUrlCompletaImagem(item.imagem_enunciado, 'questoes-imagem/')) : []
        }

        if (questao.opcao_respondida) {
          this.respostaQuestao = [questao.opcao_respondida]
        } else {
          this.respostaQuestao = []
        }

        this.exibirComentario = false

        this.respostaCorreta = null
        if ((this.isModoTreino && questao.opcao_respondida) || this.isRevisao) {
          this.respostaCorreta = questao.opcao_correta
          this.exibirComentario = true
        }

        this.adicionarOpcaoQuestao(questaoAtiva.opcoes, 1, 'a', questao.resposta1)
        this.adicionarOpcaoQuestao(questaoAtiva.opcoes, 2, 'b', questao.resposta2)
        this.adicionarOpcaoQuestao(questaoAtiva.opcoes, 3, 'c', questao.resposta3)
        this.adicionarOpcaoQuestao(questaoAtiva.opcoes, 4, 'd', questao.resposta4)
        this.adicionarOpcaoQuestao(questaoAtiva.opcoes, 5, 'e', questao.resposta5)

        return questaoAtiva
      }

      return { id: 0, pergunta: 'Não foi possível carregar esta questão, por favor entre em contato com o administrador do sitema' }
    },

    adicionarOpcaoQuestao: function (opcoes, id, letra, texto) {
      if (texto) {
        opcoes.push({ id: id, letra: letra, texto: texto })
      }
    },

    gravarTempo: function () {
      let tempoTotal = 0
      if (this.tempo) {
        tempoTotal += parseInt(this.tempo.segundos) ? parseInt(this.tempo.segundos) : 0
        tempoTotal += parseInt(this.tempo.minutos) ? parseInt(this.tempo.minutos) * 60 : 0
      }
      return SimuladoAPI.gravarTempo(this.simuladoId, tempoTotal).catch(() => {
        // do nothing
      })
    },

    finalizarSimulado: function () {
      if (this.desempenho.naoRespondidas) {
        Swal.fire({
          html: `Existem questões ainda não respondidas no ${this.configEmpresa.textosConfiguraveis.textoDisplaySimulado}. Tem certeza que deseja finalizar?`,
          icon: 'warning',
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim!',
          cancelButtonText: 'Não!'
        }).then(result => {
          if (result.value) {
            this.$loading.show()

            this.gravarTempo().then(() => {
              window.location = `/simulados/resultado/${this.simuladoId}`
            })
          }
        })
      } else {
        this.$loading.show()

        window.location = `/simulados/resultado/${this.simuladoId}`
      }
    },
    alternaTimer: function () {
      if (this.timer === 'ativo') {
        this.timer = 'inativo'
      } else {
        this.timer = 'ativo'
      }
      localStorage.setItem('timerSimulado', this.timer)
    },
    modoProva: function () {
      localStorage.setItem('execucao', 'P')
      this.execucao = 'P'
      this.$bvModal.hide('modalModoProva')
    },
    modoSimulado: function () {
      localStorage.setItem('execucao', 'S')
      this.execucao = 'S'
      this.$bvModal.hide('modalModoProva')
    },
    abrirModalModoProva: function () {
      let simuladoStorage = localStorage.getItem('simuladoId')
      if (simuladoStorage !== String(this.simuladoId)) {
        localStorage.setItem('simuladoId', this.simuladoId)
        this.modoProva()
        // this.$bvModal.show('modalModoProva')
      }
    },
    mostrarModalRelatoDeProblemaSimulado: function () {
      this.$nextTick(() => {
        this.$refs.modalRelatarProblemaSimulado.show()
      })
    },
    colorOpcaoQuestao: function (opcao) {
      if (this.respostaQuestao.length) {
        if (opcao.id === this.respostaCorreta) {
          return '#4DCDCC'
        } else if (this.respostaQuestao.includes(opcao.id)) {
          return '#F47D3A'
        }
      }
    },
    backgroundColorOpcaoQuestao: function (opcao) {
      if (document.body.classList.contains('darkMode')) {
        if (this.respostaQuestao.length) {
          if (opcao.id === this.respostaCorreta) {
            return '#2D2B34'
          } else if (this.respostaQuestao.includes(opcao.id)) {
            return '#2D2B34'
          }
        }
      } else {
        if (this.respostaQuestao.length) {
          if (opcao.id === this.respostaCorreta) {
            return '#F4F5F8'
          } else if (this.respostaQuestao.includes(opcao.id)) {
            return '#F4F5F8'
          }
        }
      }
    },
    textoRespostaOpcaoQuestao: function (opcao) {
      if (this.respostaQuestao.length) {
        if (opcao.id === this.respostaCorreta) {
          return 'Resposta correta'
        } else if (this.respostaQuestao.includes(opcao.id)) {
          return 'Resposta incorreta'
        }
      }
    },
    setModoTreino: function () {
      if (this.isModoTreino) {
        this.tipo = TipoPraticaSimulado.PROVA.id
        localStorage.setItem('execucao', 'P')
        this.execucao = 'P'
        this.$bvModal.hide('modalModoProva')
      } else {
        this.tipo = TipoPraticaSimulado.TREINO.id
        localStorage.setItem('execucao', 'S')
        this.execucao = 'S'
        this.$bvModal.hide('modalModoProva')
      }
    }
  }
}
</script>

<style>
  .disabled {
    cursor: not-allowed!important;
  }
</style>
